import type { QuizsetSearchReqOrder } from '@/api/gen/_model/quizsetSearchReqOrder';
import type { QuizsetSearchReqPeriod } from '@/api/gen/_model/quizsetSearchReqPeriod';
import { LIST_GRID_TWO_ROW_MAX_CELLS } from '@/shared/components/itemList/listGrid';
import type { UserFoldersVariables } from '@/shared/features/quiz-folder';

/**
 * 프로필 폴더 섹션이 받아 두는 폴더 수. 몇 개가 보이는지는 CSS 두 줄 규칙(`LIST_GRID_TWO_ROW_CLAMP`)이 정한다.
 * 내 퀴즈와 달리 `새 폴더` 칸이 없으므로 가장 넓은 그리드의 칸 수를 그대로 받는다.
 */
export const USER_FOLDER_PREVIEW_LIMIT = LIST_GRID_TWO_ROW_MAX_CELLS;

/**
 * 공개 폴더 전체 페이지의 한 페이지 크기(서버 상한). SSR prefetch 와 목록 훅이 같은 값을 써야 SSR 결과를 그대로 쓴다.
 */
export const USER_FOLDER_PAGE_SIZE = 20;

/**
 * 프로필 폴더 검색 조건. SSR prefetch 와 클라 훅이 이 함수 하나로 만든다 — 두 쪽 캐시 키가 갈라지면 SSR 결과를
 * 버리고 다시 받는다.
 *
 * 폴더 검색은 이름 검색과 정렬만 받는다. 퀴즈 필터를 넘기면 서버가 400 으로 거절한다.
 */
export const buildUserFolderVariables = ({
  userId,
  searchText,
  order,
  period,
  limit,
}: {
  userId: string;
  searchText: string;
  order: QuizsetSearchReqOrder;
  period?: QuizsetSearchReqPeriod;
  limit: number;
}): UserFoldersVariables => ({
  userId,
  limit,
  order,
  ...(order !== 'RECENTLY' && period && { period }),
  categoryFilters: {
    criteria: {
      ...(searchText && { searchText, searchType: 'TITLE' as const }),
    },
  },
});
